import { defaultTheme } from "react-admin";

export const theme = {
  ...defaultTheme,
  palette: {
    mode: "light",
    primary: {
      main: '#02d38d',
      light: '#33dc9f',
      dark: '#019362',
      contrastText: '#fff',
    },
    secondary: {
      main: '#000000',
      light: '#333333',
      dark: '#000000',
      contrastText: '#fff',
    },
    background: {
      default: '#f0f2f5',
      paper: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
  },
  components: {
    ...defaultTheme.components,
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'rgba(0, 0, 0, 0.04) 0px 5px 22px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
          borderRadius: 20,
          transition: 'box-shadow 0.2s ease-in-out',
          '&:hover': {
            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 8px 28px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          padding: '10px 16px',
          '&:hover': {
            backgroundColor: '#000000',
            color: '#ffffff',
          },
        },
        contained: {
          '&.MuiButton-containedPrimary': {
            backgroundColor: '#02d38d',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#019362',
            },
          },
          '&.MuiButton-containedSecondary': {
            backgroundColor: '#000000',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#333333',
            },
          },
        },
      },
      defaultProps: {
        size: 'medium',
        disableElevation: true,
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
          '& .MuiTableCell-root': {
            color: '#000000',
            fontWeight: 600,
            fontSize: '0.875rem',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #eaecf0',
          padding: '12px 16px',
          '&:first-of-type': {
            paddingLeft: '24px',
          },
          '&:last-of-type': {
            paddingRight: '24px',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'medium',
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            border: 'none',
            backgroundColor: '#fff',
            '&:hover': {
              borderColor: '#98a2b3',
              boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)',
            },
            '&.Mui-focused': {
              borderColor: '#02d38d',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(2, 211, 141, 0.1)',
            },
            '&.Mui-error': {
              borderColor: '#f04438',
              backgroundColor: '#fff',
            },
          },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#344054',
            '&.Mui-focused': {
              color: '#02d38d',
            },
            '&.Mui-error': {
              color: '#f04438',
            },
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 2,
            '&.Mui-error': {
              color: '#f04438',
            },
          },
        },
      },
    },
  },
};
